import api from './api';

export function reverse(lon, lat) {
  return api.get(`/endereco/reverse/${lon},${lat}`);
}

export function search(query, bbox, config) {
  return api.get(`/endereco/search/${query}?bbox=${bbox.toString()}`, config);
}
